// Services/TenantContentService.js
import { GetRequest, PutRequest, PostRequest } from "./HttpService";

export const getTenantContent = async () => {
  return await GetRequest("/TenantContent/get-content");
};

export const updateTenantContent = async (content) => {
  return await PutRequest("/TenantContent/update-content", content);
};

export const uploadTenantImage = async (file, field) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await PostRequest(
    `/TenantContent/upload-image?field=${encodeURIComponent(field)}`,
    formData,
    null,
    null,
    "multipart/form-data"
  );

  return response.json();
};
